import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Popover } from '@material-ui/core';
import { MdDelete, MdEdit, MdAdd, MdVisibility } from 'react-icons/md';
import { FaUserTie } from 'react-icons/fa';

import Paper from 'components/Paper';
import { LoadingPage } from 'components/Loading';
import SearchInput from 'components/SearchInput';
import Table from 'components/Table';
import { Row } from 'styles/components';
import ClientesActions from 'store/ducks/clientes';

import {
  Container,
  WrapperTable,
  WrapperAdd,
  DeleteIcon,
  EditIcon,
  ViewIcon,
  WrapperPopover,
  PopoverText,
  PopoverButton,
} from './styles';

function Clientes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { clientes, isLoading } = useSelector((state) => state.clientes);
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [search, setSearch] = useState('');

  const data = clientes.map((item) => {
    let dataInclusaoFormatted = '-';
    
    try {
      if (item.dataInclusao) {
        const dataInclusao = item.dataInclusao instanceof Date 
          ? item.dataInclusao 
          : new Date(item.dataInclusao);
        if (!isNaN(dataInclusao.getTime())) {
          dataInclusaoFormatted = format(dataInclusao, 'dd/MM/yyyy');
        }
      }
    } catch (error) {
      console.error('Erro ao formatar data:', error);
    }

    // Formatar CPF/CNPJ
    const cpfCnpj = item.cpfCnpj || '';
    let cpfCnpjFormatted = cpfCnpj;
    if (cpfCnpj.length === 11) {
      // CPF: 000.000.000-00
      cpfCnpjFormatted = cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (cpfCnpj.length === 14) {
      // CNPJ: 00.000.000/0000-00
      cpfCnpjFormatted = cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }

    // Formatar CEP
    const cep = item.cep || '';
    let cepFormatted = cep;
    if (cep.length === 8) {
      cepFormatted = cep.replace(/(\d{5})(\d{3})/, '$1-$2');
    }

    return {
      ...item,
      actions: item.id,
      id: item.id,
      nome: item.nome || '-',
      nomeFantasia: item.nomeFantasia || '-',
      cpfCnpj: cpfCnpjFormatted,
      tipoPessoa: item.tipoPessoa === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica',
      enderecoCompleto: `${item.endereco || ''}${item.numero ? ', ' + item.numero : ''}${item.complemento ? ' - ' + item.complemento : ''}${item.bairro ? ', ' + item.bairro : ''}${item.cidade ? ', ' + item.cidade : ''}${item.uf ? ' - ' + item.uf : ''}${item.cep ? ', CEP: ' + cepFormatted : ''}`.trim() || '-',
      numeroContato: item.numeroContato || '-',
      nomeContato: item.nomeContato || '-',
      dataInclusao: dataInclusaoFormatted,
      limiteCredito: item.credito ? Number(item.credito.limiteCredito || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) : '-',
      limiteUtilizado: item.credito ? Number(item.credito.limiteUtilizado || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) : '-',
      limiteDisponivel: item.credito ? Number(item.credito.limiteDisponivel || 0).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) : '-',
    };
  });

  const filteredData = data.filter(
    (item) =>
      (item.nome || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.nomeFantasia || '').toUpperCase().includes(search.toUpperCase()) ||
      (item.cpfCnpj || '').includes(search) ||
      (item.nomeContato || '').toUpperCase().includes(search.toUpperCase())
  );

  useEffect(() => {
    dispatch(ClientesActions.getClientesRequest());
  }, [dispatch]);

  const handleDelete = () => {
    if (selectedId) {
      dispatch(ClientesActions.removeClienteRequest(selectedId));
      setOpen(false);
      setAnchorEl(null);
    }
  };

  const handleEdit = (id) => {
    history.push(`/financeiro/clientes/edit/${id}`);
  };

  const handleView = (id) => {
    history.push(`/financeiro/clientes/view/${id}`);
  };

  if (isLoading) {
    return <LoadingPage />;
  }

  return (
    <Container>
      <Paper
        title="CLIENTES"
        icon={<FaUserTie size={24} style={{ color: '#122d58', marginRight: '25px' }} />}
        rightContent={
          <Row>
            <SearchInput
              onChange={(e) => setSearch(e.target.value)}
              onClear={() => setSearch('')}
              value={search}
            />
            <WrapperAdd>
              <div
                onClick={() => history.push('/financeiro/clientes/new')}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  height: '36px',
                  minWidth: '120px',
                  padding: '0 20px',
                  backgroundColor: '#FFF28D',
                  boxShadow: '0px 3px 6px #00000029',
                  borderRadius: '3px',
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#122d58',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.9';
                  e.currentTarget.style.transform = 'translateY(-1px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <MdAdd size={20} style={{ marginRight: '10px', color: '#122d58' }} />
                Novo Cliente
              </div>
            </WrapperAdd>
          </Row>
        }
      >
        <WrapperTable>
          <Table
            columns={[
              { label: 'Ações', id: 'actions' },
              { label: 'Nome', id: 'nome' },
              { label: 'Nome Fantasia', id: 'nomeFantasia' },
              { label: 'CPF/CNPJ', id: 'cpfCnpj' },
              { label: 'Tipo', id: 'tipoPessoa' },
              { label: 'Endereço', id: 'enderecoCompleto' },
              { label: 'Contato', id: 'numeroContato' },
              { label: 'Nome do Contato', id: 'nomeContato' },
              { label: 'Data Inclusão', id: 'dataInclusao' },
              { label: 'Limite Crédito', id: 'limiteCredito' },
              { label: 'Limite Utilizado', id: 'limiteUtilizado' },
              { label: 'Limite Disponível', id: 'limiteDisponivel' },
            ]}
            activePage={0}
            totalPages={Math.ceil(filteredData.length / 10)}
            data={filteredData}
            customComponent={{
              actions: (id) => (
                <Row>
                  <ViewIcon
                    onClick={() => handleView(id)}
                    style={{ marginRight: '10px' }}
                  />
                  <EditIcon
                    onClick={() => handleEdit(id)}
                    style={{ marginRight: '10px' }}
                  />
                  <DeleteIcon
                    onClick={(e) => {
                      setSelectedId(id);
                      setAnchorEl(e.currentTarget);
                      setOpen(true);
                    }}
                  />
                </Row>
              ),
            }}
          />
        </WrapperTable>
      </Paper>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <WrapperPopover>
          <PopoverText>Tem certeza que deseja excluir?</PopoverText>
          <Row>
            <PopoverButton onClick={handleDelete}>Sim</PopoverButton>
            <PopoverButton
              onClick={() => {
                setOpen(false);
                setAnchorEl(null);
              }}
            >
              Não
            </PopoverButton>
          </Row>
        </WrapperPopover>
      </Popover>
    </Container>
  );
}

export default Clientes;

